import type { TFunction } from 'i18next';
import type { CandidateSummary } from 'store/reducers/jobReducer';
import { EMPTY_SUMMARY_VALUE } from './constants';

export const formatSummarySources = (sourceCounts: CandidateSummary['source_counts'], t: TFunction): string => {
  const commentCount = sourceCounts.assignment_comments + sourceCounts.activity_comments + sourceCounts.valid_comments;
  const summarySources = [
    {
      count: commentCount,
      translationKey: 'translation:job_candidate_summary.comment',
    },
    {
      count: sourceCounts.interview_feedbacks,
      translationKey: 'translation:job_candidate_summary.interview_feedback',
    },
    {
      count: sourceCounts.decisions,
      translationKey: 'translation:job_candidate_summary.decision',
    },
    {
      count: sourceCounts.management_approvals,
      translationKey: 'translation:job_candidate_summary.management_approval',
    },
    {
      count: sourceCounts.offers,
      translationKey: 'translation:job_candidate_summary.offer',
    },
  ] as const;

  return summarySources
    .filter(({ count }) => count > 0)
    .map(
      ({ count, translationKey }) =>
        `${count} ${t(translationKey, {
          context: count === 1 ? 'singular' : 'plural',
          defaultValue: EMPTY_SUMMARY_VALUE,
        })}`
    )
    .join(', ');
};
